<div class="container-fluid" [formGroup]="formArray.controls[group]" id="DL-costs">
    <div formArrayName="thirdPartyCost">
        <label class="font-weight-bold">THIRD PARTY COSTS</label>
        <div>
            <!--TPCA Header-->
            <div class="tpc-header">
                <div class="d-inline-block add-container">
                    <acl-ngx-button icon="Add" [compact]="true" [disabled]="isDisabled" variant="static"
                        (click)="addThirdPartyCost()">
                    </acl-ngx-button>
                </div>
                <div class="d-inline-block reset-container">
                    <acl-ngx-button label="Reset" [compact]="true" [disabled]="isDisabled" variant="static"
                        (click)="resetThirdPartyCost()">
                    </acl-ngx-button>
                </div>
            </div>
            <!--TPCA Table-->
            <div class="tpc-table">
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th scope="col" class="row-costType">Cost Type</th>
                            <th scope="col" class="row-vendor">Vendor</th>
                            <th scope="col" class="row-cpmCost">CPM Cost</th>
                            <th scope="col" class="row-paidBy">Paid By</th>
                            <th scope="col" class="row-remove"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of thirdPartyCost.controls; let j = index" formGroupName="{{j}}">
                            <td class="tpc-costType tpc-select">
                                <acl-ngx-select placeholder="Select a Type" menuWidth="350px"
                                    [error]="costTypeId(j).touched && costTypeId(j).invalid"
                                    (change)="costTypeChange($event, j)" [disabled]="isDisabled"
                                    [initialValue]="initialThirdPartyCostType[j]">
                                    <acl-ngx-option *ngFor="let item of thirdPartyCostType | keyvalue"
                                        [label]="item.value.label" [value]="item.value.id">
                                    </acl-ngx-option>
                                </acl-ngx-select>
                            </td>
                            <td class="tpc-vendor tpc-select">
                                <acl-ngx-typeahead variant="borderless" placeholder="Select a Vendor"
                                    [results]="filteredTpaPlatform[j]" resultNameAccessor="name" uniqueIdAccessor="id"
                                    [error]="vendorId(j).touched && vendorId(j).invalid" [disabled]="isDisabled"
                                    [selected]="initialTpaPlatform[j]" (selectionChange)="vendorChange($event, j)"
                                    (queryChange)="filterVendor($event, j)">
                                </acl-ngx-typeahead>
                            </td>
                            <td class="tpc-cpmCost">
                                <div class="acl-FormControl fluid">
                                    <div class="acl-Input--table acl-Input-wrapper"
                                        [ngClass]="{'acl-Input--error': cPMCost(j).touched && cPMCost(j).invalid, 'acl-Input--disabled': cPMCost(j).disabled}">
                                        <div class="acl-Input-leftElement">
                                            {{currencySymbol}}
                                        </div>
                                        <input type="text" formControlName="cPMCost" currencyFormat />
                                    </div>
                                </div>
                            </td>
                            <td class="tpc-paidBy tpc-select">
                                <acl-ngx-select irreversible="true" (change)="paidByChange($event, j)" menuWidth="150px"
                                    [disabled]="isDisabled" [initialValue]="initialThirdPartyCostPaidBy[j]">
                                    <acl-ngx-option *ngFor="let item of thirdPartyCostPaidBy | keyvalue"
                                        [label]="item.value.label" [value]="item.value.id">
                                    </acl-ngx-option>
                                </acl-ngx-select>
                            </td>
                            <td class="tpc-remove">
                                <acl-ngx-button icon="Remove" [disabled]="isDisabled" [compact]="true"
                                    variant="borderless" (click)="removeThirdPartyCost(j)">
                                </acl-ngx-button>
                            </td>

                        </tr>
                        <tr class="empty-row" *ngIf="!thirdPartyCost.controls.length">
                            <td colspan="5" class="empty-row-text">Add third party cost using the button above.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div *ngIf="thirdPartyCost.touched && thirdPartyCost.invalid" class="error-feedback">
                <span>Please correct the errors in red. CPM cost should be a positive currency amount</span>
            </div>
        </div>
    </div>
</div>